import React, { useEffect, useRef, useState } from "react";
import {
  Emailvalidate,
  GETALLFILETYPEEXTENSION,
  ImageShare2ndVersion,
  Otpvalidation,
} from "../../DAM_API/urls";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Spinner } from "reactstrap";

import FolderGridSecondVersion from "../../Common/Designs/CommonFolder";
import ImageGridSecondVersion from "../../Common/Designs/CommonAssets";
import { CommonSvg } from "../../Common/SVG";
import CommonFilter from "../../Common/Filters/CommonFilter";
import { filterOptionData } from "../../Common/Filters/FilterOptions";
import CommonAuthPopup from "../../Common/CommonAuthPopup";

import "./imagePage.css";
import { useDownloadAssets } from "../../../context/DownloadAssetsContext";
import Axios from "../../../utils/Axios";

/* ---------------- Range Selection (UNCHANGED) ---------------- */

export function selectRangeByUUID(
  data,
  startId,
  endId,
  filterId = "damFileId",
) {
  const startIndex = data.findIndex((item) => item[filterId] === startId);
  const endIndex = data.findIndex((item) => item[filterId] === endId);

  if (startIndex === -1 || endIndex === -1) return data;

  const min = Math.min(startIndex, endIndex);
  const max = Math.max(startIndex, endIndex);

  return data.map((item, index) => ({
    ...item,
    isSelected: !item?.isSelected
      ? index >= min && index <= max
      : item.isSelected,
  }));
}

/* ---------------- Component ---------------- */

function Image() {
  const { id } = useParams();

  const [data, setData] = useState();
  const [videoFile, setVideoFile] = useState("");
  const [showemail, setshowemail] = useState(false);

  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [popupMode, setPopupMode] = useState("email");

  const [sharedData, setSharedData] = useState();
  const [prevIndexSelected, setPrevIndexSelected] = useState();

  const [filterState, setFilterState] = useState({});
  const [filterData, setFilterData] = useState({});

  const [siteloading, setSiteLoading] = useState(false);
  const [isFirstLoad, setIsFirstLoad] = useState(true);
  const [loading, setloading] = useState(false);
  const [buttonLoading, setButtonLoading] = useState(false);

  const emailInputRef = useRef(null);
  const otpInputRef = useRef(null);
  const { startDownload } = useDownloadAssets();

  /* ---------------- API CALL (UNCHANGED LOGIC) ---------------- */

  const Shareimage = async (id) => {
    if (
      filterState?.searchInput?.length > 0 &&
      filterState?.searchInput?.length < 3
    ) {
      return;
    }

    setSiteLoading(true);

    const _data = {
      shareUniqueId: id,
      ...(filterState?.Orientation && {
        orientations: filterState?.Orientation,
      }),
      ...(filterState?.Color && {
        dominantColor: filterState?.Color?.map((i) => i?.toLowerCase()),
      }),
      ...(filterState?.Faces?.[0] && {
        personCount:
          filterState?.Faces?.[0] === "single"
            ? 1
            : filterState?.Faces?.[0] === "Two"
              ? 2
              : 3,
      }),
      ...(filterState?.["Creation Date"] && {
        startDate: filterState?.["Creation Date"]?.[0],
      }),
      ...(filterState?.["Asset Type"] && {
        filterTypeExtension: filterState?.["Asset Type"],
      }),
      ...(filterState?.searchInput && {
        searchKeyword: filterState?.searchInput,
      }),
      ...(filterState?.isCustomData && {
        startDate: filterState?.startDate,
        endDate: filterState?.endDate,
      }),
      email,
      otp,
    };

    try {
      const response = await Axios.post(ImageShare2ndVersion, _data);

      const flatted_folder = response?.data?.data?.folders?.flatMap(
        (item) => item?.folders,
      );

      setSharedData({ ...response.data.data, folders: flatted_folder });
      setData(response.data.data);
      setVideoFile(response.data.data);
      setshowemail(response.data.success);
      setIsFirstLoad(false);
    } catch (error) {
      setshowemail(error?.response?.data?.success);
      setIsFirstLoad(false);
      console.error(error);
    } finally {
      setSiteLoading(false);
    }
  };

  /* ---------------- AUTH ---------------- */

  const handleotp = async () => {
    try {
      setButtonLoading(true);
      const res = await Axios.post(Emailvalidate, {
        email,
        uniqueId: id,
      });

      if (res.data.data.includes("OTP")) {
        setPopupMode("otp");
      } else {
        setPopupMode(null);
        setshowemail(true);
        Shareimage(id);
      }
    } catch (e) {
      toast.error(e?.response?.data?.data);
    } finally {
      setButtonLoading(false);
    }
  };

  const sendotp = async () => {
    try {
      setButtonLoading(true);
      const res = await Axios.post(Otpvalidation, {
        shareUniqueId: id,
        otp,
        email,
      });

      const flatted_folder = res?.data?.data?.folders?.flatMap(
        (item) => item?.folders,
      );

      setSharedData({ ...res.data.data, folders: flatted_folder });
      setPopupMode(null);
      setshowemail(true);
    } catch (e) {
      toast.error(e?.response?.data?.message);
    } finally {
      setButtonLoading(false);
    }
  };

  /* ---------------- DOWNLOAD ---------------- */

  const downloadHandler = async () => {
    try {
      setloading(true);
      var _data = {
        fileId: sharedData?.files
          ?.filter((i) => i?.isSelected)
          ?.map((i) => i?.assetId),
        folderId: sharedData?.folders
          ?.filter((i) => i?.isSelected)
          ?.map((i) => i?.id),
        files:sharedData?.files
          ?.filter((i) => i?.isSelected)
          ?.map((i) => i),
        email,
      };
      const res =await startDownload(_data);
    } catch {
      toast.error("Download failed");
    } finally {
      setloading(false);
    }
  };

  /* ---------------- EFFECTS ---------------- */

  useEffect(() => {
    if (id) Shareimage(id);
  }, [filterState]);

  useEffect(() => {
    Axios
      .get(GETALLFILETYPEEXTENSION)
      .then((res) => setFilterData({ assetType: res?.data?.data }))
      .catch(console.error);
  }, []);

  /* ---------------- LOADERS ---------------- */

  if (siteloading && isFirstLoad) {
    return <div className="loader-center">Loading…</div>;
  }

  /* ---------------- AUTH UI ---------------- */

  if (!showemail) {
    return (
      <CommonAuthPopup
        isOpen
        mode={popupMode}
        email={email}
        setEmail={setEmail}
        otp={otp}
        setOtp={setOtp}
        onSubmit={popupMode === "email" ? handleotp : sendotp}
        onClose={() => setPopupMode(null)}
        buttonLoading={buttonLoading}
      />
    );
  }
  const handleFolderSelect = ({ Image, Key }) => {
    setSharedData((prev) => {
      if (!prev) return prev;

      const folders = prev.folders.map((f) => {
        if (f.id === Image.id) {
          return { ...f, isSelected: !f.isSelected };
        }
        return f;
      });

      return { ...prev, folders };
    });
  };

  /* ---------------- MAIN UI ---------------- */

  return (
    <div className="container image-page">
      {/* Header */}
      <div className="page-header">
        <h2>Assets</h2>

        {(sharedData?.files?.some((i) => i?.isSelected) ||
          sharedData?.folders?.some((i) => i?.isSelected)) && (
          <button
            className="Primary-Button d-flex gap-2"
            onClick={downloadHandler}
            disabled={loading}
          >
            Download {loading && <Spinner size="sm" />}
          </button>
        )}
      </div>

      {/* Filters */}
      <div className="filter-bar">
        <div className="filter-group">
          <CommonFilter
            Title="Asset Type"
            state={filterState}
            selectedState={setFilterState}
            isSubFilter
            filterLableData={filterData.assetType}
          />
          <CommonFilter
            state={filterState}
            isSelected={filterState?.["Creation Date"]?.length > 0}
            selectedState={setFilterState}
            Title={"Creation Date"}
            isCheckSingular={true}
            // isCircledFilter={true}
            filterLableData={filterOptionData?.formats}
            isCustomDate={true}
          />
          <CommonFilter
            Title="Orientation"
            state={filterState}
            selectedState={setFilterState}
          />
          <CommonFilter
            Title="Color"
            state={filterState}
            selectedState={setFilterState}
            isCircledFilter
            filterLableData={filterOptionData.colors}
          />
          <CommonFilter
            Title="Faces"
            state={filterState}
            selectedState={setFilterState}
            isCircledFilter
            isAssets
            filterLableData={filterOptionData.faces}
          />
          <span className="reset-btn" onClick={() => setFilterState({})}>
            Reset
          </span>
        </div>

        <div className="search-box">
          {CommonSvg.searchIconSvg}
          <input
            type="search"
            placeholder="Search Assets"
            value={filterState?.searchInput || ""}
            onChange={(e) =>
              setFilterState((p) => ({
                ...p,
                searchInput: e.target.value,
              }))
            }
          />
        </div>
      </div>

      {/* Folders */}
      <div className="folder-grid">
        {sharedData?.folders?.map((item) => (
          <FolderGridSecondVersion
            Title={item?.folderName}
            Data={item}
            EllipseActions={CommonSvg.downloadIconsSvg}
            HandleSelect={(value) => {
              if (value?.Key === 3) {
                const returnedValueData = selectRangeByUUID(
                  sharedData?.folders,
                  prevIndexSelected,
                  item?.id,
                  "id",
                );
                setSharedData((prev) => ({
                  ...prev,
                  folders: returnedValueData,
                }));
              }

              if (value?.Key === 1) {
                setPrevIndexSelected(item?.id);
                setSharedData((prev) => ({
                  ...prev,
                  folders: prev?.folders?.map((_item) =>
                    _item?.id === item?.id
                      ? { ..._item, isSelected: !item?.isSelected }
                      : { ..._item, isSelected: false },
                  ),
                }));
              }

              if (value?.Key === 2) {
                setPrevIndexSelected(item?.id);
                setSharedData((prev) => ({
                  ...prev,
                  folders: prev?.folders?.map((_item) =>
                    _item?.id === item?.id
                      ? { ..._item, isSelected: !item?.isSelected }
                      : { ..._item },
                  ),
                }));
              }
            }}
            isSelected={item?.isSelected}
          />
        ))}
      </div>

      {/* Assets */}
      <div className="asset-grid">
        {sharedData?.files?.map((item, index) => (
          <div key={index}>
            {" "}
            <ImageGridSecondVersion
              Data={item}
              EllipseActions={CommonSvg.downloadIconsSvg}
              HandleSelect={(value) => {
                if (value?.Key === 3) {
                  const returnedValueData = selectRangeByUUID(
                    sharedData?.files,
                    prevIndexSelected,
                    item?.assetId,
                    "assetId",
                  );
                  setSharedData((prev) => ({
                    ...prev,
                    files: returnedValueData,
                  }));
                }

                if (value?.Key === 1) {
                  setPrevIndexSelected(item?.assetId);
                  setSharedData((prev) => ({
                    ...prev,
                    files: prev?.files?.map((_item) =>
                      _item?.assetId === item?.assetId
                        ? { ..._item, isSelected: !item?.isSelected }
                        : { ..._item, isSelected: false },
                    ),
                  }));
                }

                if (value?.Key === 2) {
                  setPrevIndexSelected(item?.assetId);
                  setSharedData((prev) => ({
                    ...prev,
                    files: prev?.files?.map((_item) =>
                      _item?.assetId === item?.assetId
                        ? { ..._item, isSelected: !item?.isSelected }
                        : { ..._item },
                    ),
                  }));
                }
              }}
              Index={index}
              isSelected={item.isSelected}
            />
          </div>
        ))}
      </div>
    </div>
  );
}

export default Image;
